import "./Page-not-found.css";
import { Link } from "react-router-dom";
import sourshipLogo from "../../assets/images/sourship-ICON-LOGO.png";

/**
 * Any address the app does not know. Self-contained on purpose: it sits outside
 * AppLayout, so it gets no sidebar and none of the shared page styles, and every
 * class it uses is defined in its own sheet.
 */
function PageNotFound() {
  return (
    <div className="pnf">
      <header className="pnf-header">
        <Link to="/dashboard" className="pnf-brand">
          <img src={sourshipLogo} alt="" />
          <span>Sourship</span>
        </Link>
        <Link to="/help" className="pnf-header-link">Help &amp; Guide</Link>
      </header>

      <div className="pnf-main">
        <div className="pnf-text">
          <span className="pnf-code">404</span>
          <h1>We can't find that page</h1>
          <p>The link may be old, or the address may have a typo.</p>
          <div className="pnf-actions">
            <Link to="/dashboard" className="pnf-btn pnf-btn-primary">Go to your dashboard</Link>
            <Link to="/help" className="pnf-btn">Open Help &amp; Guide</Link>
          </div>
        </div>
        <img className="pnf-image" src="/images/not-found-gif.gif" alt="" />
      </div>
    </div>
  );
}

export default PageNotFound;
